var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed flex h-screen w-full flex-grow flex-col items-center justify-center gap-6"},[_c('Logo',{staticClass:"size-14"}),_c('div',[_c('Alert',{attrs:{"error":_vm.error}})],1),(_vm.loading)?_c('LoadingSpinner'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }